<article class="course-card">
  <div class="course-card__header">
    <div class="course-card__hero">
      <div
        class="course-image-wrap"
        [attr.aria-label]="
          course().status === 'ARCHIVED'
            ? ('app.admin.contentPage.archivedCourseImage' | translate)
            : null
        "
      >
        @if (hasHeroImage()(course())) {
          <img
            [src]="course().courseImageUrl"
            [alt]="course().courseName"
            class="course-image-avatar"
            (error)="onImageError(course().id)"
          />
        } @else if (showHeroSpinner()(course())) {
          <div class="course-hero-spinner-wrap" role="status">
            <mat-spinner diameter="32" />
          </div>
        } @else {
          <span class="course-image-placeholder">—</span>
        }
      </div>
    </div>
    <div class="course-card__meta">
      <h3 class="course-card__name">{{ course().courseName }}</h3>
      <span class="category-badge">{{ course().category || '—' }}</span>
      <span class="course-card__status">{{ statusLabel()(course().status) }}</span>
    </div>
  </div>

  <dl class="course-card__details">
    <div>
      <dt>{{ 'app.admin.contentPage.columns.duration' | translate }}</dt>
      <dd>
        {{ course().estimatedDuration }}
        {{ 'app.admin.contentPage.minutesSuffix' | translate }}
      </dd>
    </div>
    <div>
      <dt>{{ 'app.admin.contentPage.columns.source' | translate }}</dt>
      <dd>{{ sourceLabel()(course().source) }}</dd>
    </div>
  </dl>

  @if (course().status !== 'ARCHIVED') {
    <div class="course-card__actions">
      <app-cta-button variant="light" size="small" (clicked)="openCourse.emit(course())">
        <span cta-label>{{ 'app.admin.contentPage.openCourse' | translate }}</span>
      </app-cta-button>
    </div>
  }
</article>
